
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[lang]/gdpr",
      function () {
        return require("private-next-pages/[lang]/gdpr.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[lang]/gdpr"])
      });
    }
  